export default __webpack_public_path__ + "static/media/cai-design04.bf4af0f8.jpg";